/**
 * Bold360-only flow without Genesys related features: authenticationMode: "BOLD360", isGenesysEnabled: false
 * Genesys-only flow without Bold360 authentication: authenticationMode: "GENESYS", isGenesysHybridModeDisabled: true
 * Hybrid flow: authenticationMode: "GENESYS", isGenesysHybridModeDisabled: false, needs paired organization
 */

// Check for dynamically loaded config objects
import { Features } from './models/features.model';
import { Config } from './models/config.model';
import { defaultConfig, defaultFeatures } from './environment.defaults';
import { isDCA, isDXProd, isTCA } from './environment.helper';
import { newRelicConfig } from './new-relic-config';

(<any>window).supportedLanguages = (<any>window).dxSupportedLanguages || ['en-US'];

export const environment = {
  production: false
};

// DEV/Satellite overrides
let configOverrides: Partial<Config> = {
  environment: 'dx',
  authenticationMode: 'GENESYS',
  supportedLanguages: (<any>window).supportedLanguages,
  telemetry: {
    newRelic: newRelicConfig
  }
};
let featureOverrides: Partial<Features> = {
  genesysDxChat: true,
  genesysDxEmail: true
};

if (isDCA()) {
  configOverrides = {
    ...configOverrides,
    cookieDomain: 'inindca.com'
  };
}

if (isTCA() || isDXProd()) {
  environment.production = true;
  configOverrides = {
    ...configOverrides,
    cookieDomain: isTCA() ? 'inintca.com' : 'mypurecloud.com',
    segmentIOApiKey: '8aUIs1OrWaTBUWFhB9THBYIAZKU3doNK' // logmein/boldchat-live
  };
}

export const config: Config = {
  ...defaultConfig,
  ...configOverrides,
  features: {
    ...defaultFeatures,
    ...featureOverrides
  }
};
